// src/helper/fileHelper.js

// Проверяет имя файла и эмитит события в родительский компонент.
// Возвращает объект с текстом ошибки (если есть) и File/null.
export function handleNewFile(evt, emit, options = {}) {
	const { idx = null } = options;

	// Можно переопределить паттерн и текст ошибки при необходимости
	const forbiddenPattern = options.forbiddenPattern || /[@#%&!]/;
	const errorText = options.errorText || '⚠️ Invalid characters in file name: @ # % & !';

	const inputEl = evt?.target;
	const file = inputEl?.files?.[0] || null;

	// Ничего не выбрали — сбрасываем наверх
	if (!file) {
		emit('updateFile', null);
		return { error: '', file: null };
	}

	// Проверка имени
	if (forbiddenPattern.test(file.name)) {
		if (inputEl) inputEl.value = '';
		emit('invalidFileName', { idx, name: file.name });
		emit('updateFile', null);
		return { error: errorText, file: null };
	}

	// Всё ок — пробрасываем исходное событие наверх (как и было)
	emit('updateFile', evt);
	return { error: '', file };
}
